import React, { useEffect, useRef, useState } from "react";
import { Offcanvas, Accordion, ListGroup, Button } from "react-bootstrap";

import "../Navbar/Navbar.scss";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcaseMedical,
  faCalendarDays,
  faCircleQuestion,
  faFileMagnifyingGlass,
  faHouseMedical,
  faLanguage,
  faMagnifyingGlass, faMemo, faMemoCircleCheck,
  faMemoCircleInfo,
  faUserGroup,
  faUserPlus,
} from "@fortawesome/pro-solid-svg-icons";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import useGetData from "../../hooks/useGetData";
import { useDownloadFile } from "../../hooks/useDownloadFile";
import useDocumenFile from "../../hooks/useDocumentFile";

interface MenuSidebarProps {
  handleClose: Function;
  show: boolean;
  handleLogout: Function;
  roleId: Number;
}

const MenuSidebar = ({ handleClose, show, handleLogout,roleId }: MenuSidebarProps) => {

  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);
  const [settings, setSystemSettings] = useState<any>(null);
  const hasFetched = useRef(false); 

  interface UserDetails {
    roleId: number;
    roleName: string;
    routinizedHospitalName: string;
    // Add other properties based on your API response
    }


  const { getDataById: getUserId } = useGetData<any, string>(
    "UserSecurity/GetUserSecurityByEmail/"+account.username,
    "GET"
  );

  const { getDataById: getSystemSettings } = useGetData<any, string>(
    "Client/GetSystemSettings",
    "GET"
  );

 
  const { downloadFile, isProgress, errorMsg } = useDocumenFile(
    "Document", // The API endpoint for the file (adjust accordingly)
    "GET"       // HTTP method (typically "GET" for downloading files)
  );

  useEffect(() => {
    const fetchUserData = async () => {
        try {
            const userData = await getUserId("");
            if (userData?.user) {
                setUserDetails({ ...userData.user }); // Update state
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    const fetchSystemSettings = async () => {
      try {
          const settingData = await getSystemSettings("");
         if(settingData){
          setSystemSettings(settingData);
         }
      } catch (error) {
          console.error("Error fetching user data:", error);
      }
  };
 // fetchSystemSettings();

    if (isAuthenticated && !hasFetched.current) {
        hasFetched.current = true; // Mark as fetched
        fetchUserData();
        fetchSystemSettings();
    }
}, [isAuthenticated, getUserId]); // Dependency array
     const handleOpenDocument = async () => {
    try {
      // Replace this with your actual API call
      await downloadFile("FL Health Care Lookup User Guide");
    } catch (error) {
      console.error("Error fetching document:", error);
    }
  };

  const checkMenuActive = (menuName: string) => {
      if(settings){
        return settings.find((x: { systemSettingName: string; isActive: any; })=>x.systemSettingName==menuName && x.isActive)
      }
  };


    return (
        <>
            <Offcanvas className="nav-sidebar-menu" style={{ marginTop: "5.2%" }} backdropClassName="opacity-0" show={show} placement={'end'} onHide={handleClose}>
                <Offcanvas.Body className="nav-sidebar-menu-body">
                    <Accordion defaultActiveKey={['0']} alwaysOpen>

                    <Accordion.Item eventKey="0">
                    <Accordion.Body className="menu-items">
                                <ListGroup variant="flush">
                                    <ListGroup variant="flush">
                                        <NavLink to={'/dashboard'}><ListGroup.Item onClick={() => handleClose()} className="nav-menu-list-item-group"><FontAwesomeIcon icon={faMagnifyingGlass} />Search</ListGroup.Item></NavLink>
                                    </ListGroup>
                                </ListGroup>
                    </Accordion.Body>
                    </Accordion.Item>
                    
                    <Accordion.Item eventKey="0">
                    <Accordion.Body className="menu-items">
                                <ListGroup variant="flush">
                                    <ListGroup variant="flush">
                                        <NavLink to={'/ProviderDashboard'}><ListGroup.Item onClick={() => handleClose()} className="nav-menu-list-item-group"><FontAwesomeIcon icon={faMemoCircleCheck} />Dashboard</ListGroup.Item></NavLink>
                                    </ListGroup>
                                </ListGroup>
                    </Accordion.Body>
                    </Accordion.Item>
                        <Accordion.Item eventKey="1">
                        {roleId==1 ||roleId==2?(
                            <Accordion.Item eventKey="1">
                                    <Accordion.Header className='font-style'><><FontAwesomeIcon icon={faBriefcaseMedical} /> &nbsp;&nbsp; Post Low/No-Cost Service or<br/>&nbsp;&nbsp; Event</> </Accordion.Header>

                  <Accordion.Body className="menu-items">
                    <ListGroup variant="flush">
                      <ListGroup variant="flush">
                        <NavLink to={"/Events"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group font-style"
                          >
                            <FontAwesomeIcon icon={faCalendarDays} /> One Time
                            Event
                          </ListGroup.Item>
                        </NavLink>
                        <NavLink to={"/Providers"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group font-style"
                          >
                            <FontAwesomeIcon icon={faHouseMedical} /> Ongoing
                            Screening Facility
                          </ListGroup.Item>
                        </NavLink>
                      </ListGroup>
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                ""
              )}

              {roleId == 1 ? (
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <FontAwesomeIcon icon={faMemoCircleCheck} />
                    &nbsp;&nbsp;Review
                  </Accordion.Header>

                  <Accordion.Body className="menu-items">
                    <ListGroup variant="flush">
                      <ListGroup variant="flush">
                        <NavLink to={"/Review"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group"
                          >
                            <FontAwesomeIcon icon={faMemoCircleCheck} />
                            Review Submissions
                          </ListGroup.Item>
                        </NavLink>
                      </ListGroup>
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                ""
              )}

             {userDetails?.roleName === "Admin" || userDetails?.roleName === "Program Admin" || userDetails?.roleName === "HIV Program Admin"
              || userDetails?.roleName === "STD Program Admin" ? (
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <FontAwesomeIcon icon={faUserGroup} />
                    &nbsp;&nbsp;User Management
                  </Accordion.Header>

                  <Accordion.Body className="menu-items">
                    <ListGroup variant="flush">
                      <ListGroup variant="flush">
                        <NavLink to={"/user/create"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group"
                          >
                            <FontAwesomeIcon icon={faUserPlus} />
                            Add User
                          </ListGroup.Item>
                        </NavLink>
                        <NavLink to={"/user/Dashboard"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group"
                          >
                            <FontAwesomeIcon icon={faUserGroup} />
                            User Dashboard
                          </ListGroup.Item>
                        </NavLink>
                      </ListGroup>
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              ) :null}

              {(userDetails?.roleName !== "Staff" && userDetails?.roleName !== "HIV Staff" &&  userDetails?.roleName !== "STD Staff" && checkMenuActive("FacilityMainMenu"))?( // FacilityMainMenu from fc.SystemSetting
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <FontAwesomeIcon icon={faHouseMedical} />
                    &nbsp;&nbsp;Facility Management
                  </Accordion.Header>
                  

                  <Accordion.Body className="menu-items">
                    <ListGroup variant="flush">
                      <ListGroup variant="flush">
                      {userDetails?.roleName !== "Staff" && userDetails?.roleName !== "HIV Staff" &&  userDetails?.roleName !== "STD Staff"  ? (
                        <NavLink to={"/Facility/Dashboard"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group"
                          >
                            <FontAwesomeIcon icon={faBriefcaseMedical} />
                            Facility/User Management
                          </ListGroup.Item>
                        </NavLink>
                      ):("")}
                      {/* {userDetails?.roleName !== "Staff"  ? (
                        <NavLink to={"/Facility/Review"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group"
                          >
                            <FontAwesomeIcon icon={faFileMagnifyingGlass} />
                            
                            Review Facility/User Request
                          </ListGroup.Item>
                        </NavLink>
                      ):("")} */}
                      {userDetails?.roleName !== "Staff" && userDetails?.roleName !== "Provider" && userDetails?.roleName !== "HIV Provider" && 
                      userDetails?.roleName !== "STD Provider" ? (
                        <NavLink to={"/Facility/Review"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group"
                          >
                            <FontAwesomeIcon icon={faMemoCircleCheck} />
                            Facility Registration List
                          </ListGroup.Item>
                        </NavLink>
                        ):("")}
                        {userDetails?.roleName !== "Staff" && userDetails?.roleName !== "Provider" && userDetails?.roleName !== "HIV Provider" && 
                      userDetails?.roleName !== "STD Provider" ? (
                        <NavLink to={"/FacilityRegistration"}>
                          <ListGroup.Item
                            onClick={() => handleClose()}
                            className="nav-menu-list-item-group"
                          >
                            <FontAwesomeIcon icon={faMemoCircleCheck} />
                            Care Lookup Portal Registration Form
                          </ListGroup.Item>
                        </NavLink>
                      ):("")}
                      </ListGroup>
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                ""
              )}

<Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <FontAwesomeIcon icon={faMemo} />
                    &nbsp;&nbsp;System Support
                  </Accordion.Header>

                  <Accordion.Body className="menu-items">
                    <ListGroup variant="flush">
                      <ListGroup variant="flush">
                        
                          <ListGroup.Item
                            onClick={() => handleOpenDocument()}
                            className="nav-menu-list-item-group" style={{cursor:"pointer"}}
                          >
                            <FontAwesomeIcon icon={faMemoCircleInfo} />
                            User Manual
                          </ListGroup.Item>
                        
                        
                      </ListGroup>
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
            </Accordion.Item>
          </Accordion>
          <ListGroup variant="flush">
            {/* <ListGroup.Item className="nav-menu-list-item-group">
              <FontAwesomeIcon icon={faCircleQuestion} /> About FL Care
            </ListGroup.Item> */}
            <ListGroup.Item className="nav-menu-list-item-group">
              <Button onClick={() => handleLogout()} className="logout-btn">
                Logout
              </Button>
            </ListGroup.Item>
          </ListGroup>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default MenuSidebar;
